import Vue from "vue";
import { i18n } from "./../main";
import errorReportingService from "./errorReporting.service";

class ToastService {
  ShowSuccess(message: string) {
    Vue.$toast.open({
      message: i18n.t(message) as string,
      type: "success",
    });
  }
  ShowError(message: string) {
    if (message === "toast-generic" && errorReportingService.wasRecentlyReported()) {
      return;
    }
    Vue.$toast.open({
      message: i18n.t(message) as string,
      type: "error",
    });
  }
  ShowRawError(message: string) {
    Vue.$toast.open({
      message,
      type: "error",
    });
  }
  ShowInfoMessage(message: string) {
    Vue.$toast.info(i18n.t(message) as string);
  }
}

export default new ToastService();
